var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popbox show",staticStyle:{"display":"block"}},[_c('div',{staticClass:"popbox-overlay overlay"},[_c('div',{staticClass:"popbox-container"},[_c('div',{staticClass:"slideshow-container"},[_c('div',{staticClass:"mySlides img img1"})])])])])
}]

export { render, staticRenderFns }